/** Map Supabase Auth errors to safe, specific messages. */
export function authErrorMessage(error: unknown): string {
  const e = (error ?? {}) as { code?: string; message?: string; status?: number; name?: string };
  const code = e.code ?? '';
  const message = e.message ?? '';
  // supabase-js labels every 5xx as AuthRetryableFetchError too; only status 0 means the request never got through.
  const status = typeof e.status === 'number' ? e.status : 0;
  if (status >= 500) {
    if (/sending .*email|smtp/i.test(message)) return 'We couldn’t send the email just now. Please try again in a few minutes.';
    return 'Something went wrong on our side. Please try again in a few minutes.';
  }
  if (e.name === 'AuthRetryableFetchError' || /fetch|network/i.test(message)) return 'Can’t reach the server. Check your connection and try again.';
  switch (code) {
    case 'invalid_credentials':
      return 'That email and password don’t match an account.';
    case 'email_not_confirmed':
      return 'Confirm your email first — check your inbox for the link.';
    case 'user_already_exists':
    case 'email_exists':
      return 'An account with this email already exists. Sign in instead.';
    case 'weak_password':
      return 'Choose a stronger password (at least 8 characters).';
    case 'over_request_rate_limit':
    case 'over_email_send_rate_limit':
      return 'Too many attempts. Wait a minute and try again.';
    case 'same_password':
      return 'Choose a password you haven’t used for this account.';
    case 'validation_failed':
      return 'Enter a valid email address.';
    case 'signup_disabled':
      return 'New sign-ups are turned off right now.';
    default:
      return /invalid login/i.test(message) ? 'That email and password don’t match an account.' : 'Something went wrong. Please try again.';
  }
}

export const PASSWORD_MIN = 8;
